const DAIKIN_THERMOSTATS_LIST = (state, thermostatsList) => {
  state.daikinThermostatsList = thermostatsList;
};

export default {
  DAIKIN_THERMOSTATS_LIST,
};
